// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__COQdE","content":"GlobalSearch_content__14Loc"};